import { Component, OnInit } from '@angular/core';
import { StorageService } from '../Services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-congres-virtuel-industrie',
  templateUrl: './congres-virtuel-industrie.component.html',
  styleUrls: ['./congres-virtuel-industrie.component.scss']
})
export class CongresVirtuelIndustrieComponent implements OnInit {

  loginBoxShow = {display:false};

  con_user = null;

  constructor(private storagedata:StorageService, private router:Router) {
    this.con_user = storagedata.getCongresConUser()
   }

  ngOnInit() {
  }

  showLoginBox(){
    this.con_user ? this.router.navigateByUrl('/congres-virtuel/welcome') : this.loginBoxShow.display = true;
  }

  goToRegisterPage(){
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

}
